import React from 'react';
import { Col } from 'react-bootstrap';

import { InventoryCard, ItemAchievement } from '.';
import { BankResponse } from '../../../../../../types/responses/bank-response';
import { GameDocumentContext } from '../../../../../../contexts/game-document';

export const Bank: React.FC<{
  bank: BankResponse | undefined;
  setItemCard: React.Dispatch<
    React.SetStateAction<ItemAchievement | undefined>
  >;
}> = ({ bank, setItemCard }) => {
  const [gameDocument] = React.useContext(GameDocumentContext);

  const preGameSetting = gameDocument.gameDocument?.settings.preGame;

  return (
    <Col className={'p-0 ml-2 mr-0 h-100 flex-grow-1 overflow-hidden'}>
      <div
        className={'h-100 d-flex flex-column flex-grow-1 gap-3'}
        style={{
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #CFD4D9'
        }}>
        <h2 className={'m-0 fw-bold'}>Bank</h2>

        {bank && bank.items.length > 0 && (
          <div
            className={
              'gap-3 h-100 d-flex flex-column flex-grow-1 overflow-auto'
            }>
            <div className={'gap-2 d-flex flex-wrap'}>
              {(gameDocument.gameDocument?.assets.items ?? [])
                .filter(
                  (item) =>
                    item.useBank && !item.hideInGame && !item.bankItemGroupId
                )
                .map((item) => (
                  <InventoryCard
                    key={item.id}
                    item={item as ItemAchievement}
                    items={bank.items}
                    action={'acquire'}
                    isTeamGame={preGameSetting?.isPreGameTeamRequired ?? false}
                    setItemCard={setItemCard}
                  />
                ))}
            </div>

            {gameDocument.gameDocument?.assets.bankItemGroups?.map((group) => {
              const items = (
                gameDocument.gameDocument?.assets.items ?? []
              ).filter(
                (item) =>
                  item.useBank &&
                  !item.hideInGame &&
                  item.bankItemGroupId === group.id
              );

              if (!items.length) return;
              return (
                <div className={'d-flex flex-column'} key={group.id}>
                  <span
                    style={{
                      fontSize: '18px'
                    }}>
                    <b>{group.name}</b> (Max {group.maxItemsPerPlayer}{' '}
                    {group.maxItemsPerPlayer > 1 ? 'items' : 'item'} per{' '}
                    {preGameSetting?.isPreGameTeamRequired ? 'team' : 'player'})
                  </span>

                  <div className={'gap-2 d-flex flex-wrap'}>
                    {items.map((item) => (
                      <InventoryCard
                        key={item.id}
                        item={item as ItemAchievement}
                        items={bank.items}
                        action={'acquire'}
                        isTeamGame={
                          preGameSetting?.isPreGameTeamRequired ?? false
                        }
                        setItemCard={setItemCard}
                      />
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Col>
  );
};
